import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import TextHeadingOne from '../atoms/TextHeadingOne';
import TextParagraph from '../atoms/TextParagraph';
import FormButton from '../atoms/FormButton';
import Modal from './Modal';
import LabeledTextfield from '../molecules/LabeledTextfield';
import LabeledSelect from '../molecules/LabeledSelect';

//Returning the component
class FormCreditCard extends Component {
	render() {
		return (
			<Modal modalClass={this.props.modalClass}>
				<form className={`form formDeleteBot ${this.props.formWrapperClassType}`}>
					<TextHeadingOne text="Add credit card" />
					<TextParagraph text="Enter the details below" />
					{/* Card number */}
					<LabeledTextfield
						formGroupClassType={this.props.formGroupClassType}
						labelFor="cardNumber"
						labelText="Card number"
						labelId="cardNumber"
						textfieldClassType={this.props.textfieldClassType}
						textfieldId="cardNumber"
						textfieldPlaceholder={this.props.cardNumber}
						textfieldName='cardNumberInput'
						textfieldOnChange={this.props.cardNumberOnChange}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={this.props.errorMessageCardNumber}
						required={true}
						inputType="number"
					/>
					{/* Card holder */}
					<LabeledTextfield
						formGroupClassType={this.props.formGroupClassType}
						labelFor="cardHolder"
						labelText="New password"
						labelId="cardHolder"
						textfieldClassType={this.props.textfieldClassType}
						textfieldId="cardHolder"
						textfieldPlaceholder={this.props.cardHolder}
						textfieldName='cardHolderInput'
						textfieldOnChange={this.props.cardHolderOnChange}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={this.props.errorMessageCardHolder}
						required={true}
						inputType="text"
					/>
					<div className="row">
						<div className="col-sm-12 col-md-4 col-lg-4">
							{/* Expiration date */}
							<LabeledSelect
								formGroupClassType=""
								labelFor="month"
								labelText="Expiration date"
								labelId="month"
								selectClassType="Value"
								selectId="month"
								selectName="month"
								selectChildren="month"
								selectRequired="required"
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageMonth}
							/>
						</div>

						<div className="col-sm-12 col-md-4 col-lg-4">
							{/* Expiration date */}
							<LabeledSelect
								formGroupClassType="form__group--noLabel"
								labelFor="year"
								labelText="Year"
								labelId="year"
								selectClassType="Value"
								selectId="year"
								selectName="year"
								selectChildren="year"
								selectRequired="required"
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageYear}
							/>
						</div>
						<div className="col-sm-12 col-md-4 col-lg-4">
							{/* Expiration date */}
							<LabeledSelect
								formGroupClassType=""
								labelFor="cvc"
								labelText="CVC"
								labelId="cvc"
								selectClassType="Value"
								selectId="cvc"
								selectName="cvc"
								selectChildren="cvc"
								selectRequired="required"
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageCvc}
							/>
						</div>
					</div>
					<FormButton text="Add card" classType="btn--fullWidth" onClick={this.props.onClick} />

					<div className="btnRow">
						<FormButton text="Update card" onClick={this.props.onClick} />
						<FormButton text="Delete card" onClick={this.props.onClick} />
					</div>
				</form>
			</Modal>
		)
	}
}

//Making sure that it has a text property when it's declared
FormCreditCard.propTypes = {
	test: PropTypes.string, //Write some props here if needed, just using this to not have errors
}

export default FormCreditCard;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormCreditCard.jsx